import { memo, type MouseEvent, type PropsWithChildren, useRef } from "react";

import { ButtonView } from "@react/components/Button/Button.view";
import { type IconName } from "@react/components/Icon";
import { type TTailwindString } from "classnames";

export type ButtonType =
  | "primary"
  | "primary-alt"
  | "secondary"
  | "secondary-white"
  | "secondary-alt"
  | "tertiary"
  | "quaternary"
  | "quaternary-alt"
  | "pill-char"
  | "pill-brick"
  | "pill-outline"
  | "link";
export type Size = "small" | "large";

type OptionalProps = Partial<{
  "aria-label": string;
  className: TTailwindString;
  disabled: boolean;
  fluid: boolean;
  iconClassName: TTailwindString;
  iconName: IconName;
  iconPosition: "start" | "end";
  id: string;
  inherit: boolean;
  inline: boolean;
  isLoading?: boolean;
  mtrAs: string;
  mtrTarget: string;
  mtrTrack: "click" | false;
  rounded?: boolean;
  size: Size;
  type: ButtonType;
}>;

type ButtonAsLink = OptionalProps & {
  as: "link";
  external?: boolean;
  to: string;
};

type ButtonAsButton = OptionalProps & {
  as?: "button";
  onClick: (e: MouseEvent<HTMLElement>) => void;
};

const ButtonBase = (
  props: PropsWithChildren<ButtonAsLink | ButtonAsButton>
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ref = useRef<HTMLDivElement>() as unknown as any;

  return <ButtonView ref={ref} {...props} />;
};

export const Button = memo(ButtonBase);
